import keyMirror from 'keymirror';

const EDIT_MODE = keyMirror({
    BLOCK_MODE: 1,
    PYTHON_MODE: 2,
});

export {
    EDIT_MODE
}